import { render, staticRenderFns } from "./CreateLocationEventType.vue?vue&type=template&id=36743fc7"
import script from "./CreateLocationEventType.vue?vue&type=script&lang=js"
export * from "./CreateLocationEventType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports